import { render, staticRenderFns } from "./deleteContactDialog.vue?vue&type=template&id=5bcb1c16&scoped=true"
import script from "./deleteContactDialog.vue?vue&type=script&lang=ts"
export * from "./deleteContactDialog.vue?vue&type=script&lang=ts"
import style0 from "./deleteContactDialog.vue?vue&type=style&index=0&id=5bcb1c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcb1c16",
  null
  
)

export default component.exports